var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLargeArrowTopLight = function SvgIconLargeArrowTopLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.745 19.328a.232.232 0 0 0-.067.05l-.004.003-11.2 11.1-1.548-1.562 11.196-11.097.002-.002a2.298 2.298 0 0 1 1.626-.695c.619 0 1.192.26 1.628.697l11.1 11.1-1.556 1.556-11.1-11.1a.233.233 0 0 0-.067-.05l-.005-.002c-.001 0-.003 0-.005.002Z",
    fill: "#121619"
  })));
};
export default SvgIconLargeArrowTopLight;